import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/api";
import { ShieldCheck, Mail, Lock, ArrowRight, FileText } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail, "Giriş yapılamadı"));
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <div className="auth-visual">
        <div className="auth-brand">
          <div className="brand-mark"><FileText size={22} strokeWidth={2.4}/></div>
          <div><strong>GÜNLÜK RAPOR</strong><span>EKİP TAKİP SİSTEMİ</span></div>
        </div>
        <div className="auth-quote">
          <p className="eyebrow">2026 · Yönetim Merkezi</p>
          <h1>Günün özetini<br/><span className="accent">tek yerden görün.</span></h1>
          <p className="subheading">Her çalışan bugün ne üzerinde çalıştığını, hangi görevleri bitirdiğini kısa bir raporla paylaşır. Siz de hepsini anlık takip edersiniz.</p>
        </div>
        <div className="auth-features">
          <div><ShieldCheck size={16}/> Yetkili kullanıcılara özel</div>
          <div><ArrowRight size={16}/> Günlük 17:00 otomatik hatırlatma</div>
        </div>
      </div>
      <div className="auth-form-wrap">
        <form onSubmit={submit} className="auth-form" data-testid="auth-form">
          <p className="eyebrow">Hoş geldiniz</p>
          <h2>Giriş yap</h2>
          <p className="subheading">Lütfen yöneticiden aldığınız bilgilerle giriş yapın.</p>

          <label>E-posta
            <div className="field"><Mail size={15}/>
              <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}
                required placeholder="ornek@firma.com" data-testid="auth-email-input"/>
            </div>
          </label>
          <label>Parola
            <div className="field"><Lock size={15}/>
              <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)}
                required minLength={6} data-testid="auth-password-input"/>
            </div>
          </label>
          {error && <div className="form-error" data-testid="auth-error">{error}</div>}
          <button className="primary-button auth-submit" type="submit" disabled={loading} data-testid="auth-submit-button">
            {loading ? "İşleniyor..." : "Giriş yap"} <ArrowRight size={16}/>
          </button>

          <p className="auth-footer-note" data-testid="auth-restricted-note">
            <ShieldCheck size={13}/> Yeni kullanıcılar yalnızca yönetici tarafından eklenebilir.
          </p>
        </form>
      </div>
    </div>
  );
}
